import styled, { css } from "styled-components"

const StrikethroughRow = styled.tbody`
  position: relative;

  ${props =>
    props.$showStrikethrough &&
    css`
      &::after {
        content: "";
        position: absolute;
        top: calc(100% - 22px);
        left: 25px;
        width: calc(100% - 50px);
        border-top: 1px solid #ff0000;
        pointer-events: none;
        z-index: 3;
      }
    `}
`

export default StrikethroughRow
